import DefaultLayout from "src/components/DefaultLayout/DefaultLayout";
import { Slider } from "src/components/SliderComponent/Slider";
import { SplitPage } from "src/components/SplitPage/SplitPage";

export const ParseComponents: React.FC<{ data; componentsMap? }> = ({
  data,
  componentsMap = BaseComponentsMap,
}) => {
  if (!data) return null;
  return (
    <Slider>
      {data?.map((item: { _modelApiKey: string; id: string }) => {
        const reference = item._modelApiKey;
        const Component = componentsMap[reference];
        const props = item;
        if (!Component) return null;
        return <Component key={reference + item.id} {...props} />;
      })}
    </Slider>
  );
};

export const BaseComponentsMap = {
  default: DefaultLayout,
  split_page: SplitPage,
};
